import PanelGroup from './components/PanelGroup';

const selectors = {
  node: '.node-home-quicklinks',
};

export default class HomeQuicklinks {
  constructor(element) {
    this.element = element;
    this.selectors = selectors;
    this.createPanelGroups();
  }

  createPanelGroups() {
    this.nodes.forEach((node) => {
      if (!node.PanelGroup) {
        node.PanelGroup = new PanelGroup(node, this.selectors);
      }
    });
  }

  get nodes() {
    return this.element.querySelectorAll(this.selectors.node);
  }
}
